import React from "react";
import clsx from "clsx";
import { Icons, Box, Typography } from "@curves/ui-base";

const SmartFitnessBandFeeBox = props => {
	const { className, name, variantName, onClick } = props;
	return (
		<Box className={clsx("product-box", className, "py-3")} onClick={onClick}>
			<Box className="product-box-img">
				<Icons.Ring fontSize="large" />
			</Box>
			<Box className="product-box-desc">
				{name && variantName ? (
					<Typography className="product-box-title" variant="h3">{`${name} ${variantName}`}</Typography>
				) : (
					<Typography className="product-box-title" variant="h3">
						{name}
					</Typography>
				)}
			</Box>
		</Box>
	);
};

export default SmartFitnessBandFeeBox;
